// Environment detection
const isDevelopment = import.meta.env.DEV;
const isProduction = import.meta.env.PROD;
const mode = import.meta.env.MODE; // 'development', 'production', etc.

// CI-deployed admin and Team Board builds inject VITE_API_BASE_URL. A local
// admin build or development-mode build without an .env file falls back to the
// dev API, so an unset variable fails toward the safe environment rather than
// at production. A Team Board production build refuses to run without it.
// Module-local: `getApiUrl` and `logConfig` below read it.
const API_CONFIG = {
  BASE_URL:
    import.meta.env.VITE_API_BASE_URL ||
    "https://dev.api.dashpet.getdashmote.com",
  ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT || "development",
  DEBUG_MODE: import.meta.env.VITE_DEBUG_MODE === "true" || isProduction,

  // Environment flags
  IS_DEVELOPMENT: isDevelopment,
  IS_PRODUCTION: isProduction,
  MODE: mode,
};

// Environment-specific configurations
export const getApiUrl = (endpoint = "") => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};

export const logConfig = () => {
  if (API_CONFIG.DEBUG_MODE) {
    console.log("🔧 Environment Config:", {
      mode: API_CONFIG.MODE,
      baseUrl: API_CONFIG.BASE_URL,
      environment: API_CONFIG.ENVIRONMENT,
    });
  }
};

export const getApiHeaders = () => ({
  "content-type": "application/json",
});
